module.exports = __webpack_public_path__ + "img/11-5.57035aae.png";